import { IconInfoCircle } from '@consta/icons/IconInfoCircle'
import type { ButtonPropForm, ButtonPropView } from '@consta/uikit/Button'
import { Button } from '@consta/uikit/Button'
import type { PopoverPropOffset } from '@consta/uikit/Popover'
import { Popover } from '@consta/uikit/Popover'
import { Show } from '@library/components'
import { useBooleanFlag } from '@library/hooks'
import classNames from 'classnames'
import type { Nullable } from 'common/types'
import type { FC, PropsWithChildren, RefObject } from 'react'
import { useRef } from 'react'

import { ShortcutsContent } from './ShortcutsContent'
import css from './ShortcutsPanel.css'

type ShortcutsPanelProps = {
  className?: string
  view?: ButtonPropView
  form?: ButtonPropForm
  anchorRef?: RefObject<HTMLElement>
  offset?: PopoverPropOffset
}

export const ShortcutsPanel: FC<PropsWithChildren<ShortcutsPanelProps>> = ({
  children,
  className,
  view = 'clear',
  form = 'round',
  anchorRef,
  offset = 'm',
}) => {
  const [isOpen, { toggle, setFalse }] = useBooleanFlag(false)
  const fallbackRef = useRef<Nullable<HTMLButtonElement>>(null)
  const resultClass = classNames(className, css.buttonPanel)

  const finalRef = anchorRef ?? fallbackRef

  return (
    <>
      <div className={resultClass}>
        <Button
          ref={fallbackRef}
          size="xs"
          form={form}
          view={view}
          label="Горячие клавиши"
          onlyIcon={true}
          iconLeft={IconInfoCircle}
          onClick={toggle}
        />
      </div>
      <Show when={isOpen}>
        <Popover
          anchorRef={finalRef}
          className={css.content}
          offset={offset}
          direction="rightStartUp"
          spareDirection="rightStartUp"
          placeholder={undefined}
          onClickOutside={setFalse}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}>
          <ShortcutsContent closeShortcutsPanel={setFalse}>{children}</ShortcutsContent>
        </Popover>
      </Show>
    </>
  )
}
